import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";

export function useVariluxGoalsDelete() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function deleteVariluxGoals(segmentationId, variluxGoalsId) {
        if (!segmentationId) {
			setError("Não foi possível identificar o tamanho do cliente.");

			return {
				ok: false,
				reason: "validation",
				error: "Não foi possível identificar o tamanho do cliente."
			};
		}

		if (!variluxGoalsId) {
			setError("Não foi possível identificar a meta Varilux.");

			return {
				ok: false,
				reason: "validation",
				error: "Não foi possível identificar a meta Varilux."
			};
		}

        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const requestOptions = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                }
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}/varilux/${encodeURIComponent(variluxGoalsId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível excluir a meta Varilux."
                );
            }

            return {
                ok: true
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        deleteVariluxGoals
    };
}